import { Language } from '@gig/magic-sdk/dist/adapter/users/language';

const localeList: Record<Language, string> = {
    [Language.CANADIAN]: 'en-CA',
    [Language.CANADIAN_FRENCH]: 'fr-CA',
    [Language.ENGLISH]: 'en',
    [Language.SWEDISH]: 'sv-SE',
    [Language.GERMAN]: 'de-DE',
    [Language.NORWEGIAN]: 'no-NO',
    [Language.DUTCH]: 'nl-NL',
    [Language.TURKISH]: 'tr-TR',
    [Language.DANISH]: 'da-DK',
    [Language.BRITISH]: 'en-GB',
    [Language.AUSTRALIAN]: 'en-AU',
    [Language.NEW_ZEALAND]: 'en-NZ',
    [Language.RUSSIAN]: 'ru-RU',
    [Language.LATVIAN]: 'lv-LV',
    [Language.SPANISH]: 'es-ES',
    [Language.MACEDONIAN]: 'mk-MK',
    [Language.HUNGARIAN]: 'hu-HU',
    [Language.JAPANESE]: 'ja-JP',
    [Language.HINDI]: 'hi-IN',
    [Language.FINNISH]: 'fi-FI',
    [Language.THAI]: 'th-TH',
    [Language.ARGENTINE_SPANISH]: 'es-AR',
    [Language.ROMANIAN]: 'ro-RO',
    [Language.SOUTH_AFRICAN]: 'en-ZA',
    [Language.CHILEAN]: 'es-CL',
    [Language.MANDARIN]: 'zh-CN',
    [Language.PERU]: 'es-PE',
    [Language.BRAZILIAN_PORTUGUESE]: 'pt-BR',
    [Language.ESTONIAN]: 'et-EE',
    [Language.IRISH]: 'en-IE',
};

// The locale must be provided in BCP 47 language tag
export const locale = (lang: string) => localeList[lang as Language] || lang;
